import { useState, useCallback } from 'react'

export const useHeightSyncState = () => {
  const [heights, setHeights] = useState<Record<string, number>>({})

  const registerHeight = useCallback((id: string, height: number) => {
    if (height > 0) {
      setHeights((prev) => {
        if (prev[id] === height) {
          return prev
        }

        return { ...prev, [id]: height }
      })
    }
  }, [])

  const heightValues = Object.values(heights)
  const maxHeight = heightValues.length > 0 ? Math.max(...heightValues) : 0

  return { registerHeight, maxHeight }
}
